<template>
  <div class="indexBox bg">
    <img class="WLJY_logo" v-if="matchId == 219 || matchId == 220 || matchId == 221 || matchId == 222 || matchId == 223"
      src="https://mc.posedu.com.cn/myAll_Img/WLJY_logo.png" style="left: 4.375rem;top: 3.75rem;" />
      <img  :src="hostUrl" alt="" style="height: 4.8rem;position: absolute;left: 2.5rem;top: 2rem;" v-if="hostUrl">
    <img  :src="technicalSupportUrl" alt="" style="height: 4.8rem;position: absolute;right: 2.5rem;top: 2rem;" v-if="hostUrl && technicalSupportUrl">
    <img  :src="technicalSupportUrl" alt="" style="height: 4.8rem;position: absolute;left: 2.5rem;top: 2rem;" v-if="!hostUrl && technicalSupportUrl">

      <div class="bigTitleBack bg">
      <div class="bigTitle">{{rankingStatus==0?'选手成绩':'选手排名'}}</div>
    </div>
    <!-- 选手信息 -->
    <div class="tableBox">
      <div class="tableBox_title">
        <div class="myTh myThOne" style="font-size: 2rem;">{{ rankingStatus==0?'出场顺序':(matchId == 304 || matchId == 305 || matchId == 306 || matchId == 307 || matchId == 308?'当前排名':'序号')}}</div>
        <div class="myTh myThTwo" style="font-size: 2rem;">
          {{ '选手姓名' }}</div>
        <div class="myTh myThThree">
          {{ currentShowSchoolInfo == 1 ? '学校名称' : '专业'}}</div>
        <div class="myTh myThFour" style="font-size: 2rem;">分数</div>
      </div>
      <div class="tableBox_main" v-for="(item, index) in grade_rank" :key="index">
        <div class="myTh myThOne">{{ rankingStatus==0?item.sort:index+1+(currPage-1)*10 }}</div>
        <div class="myTh myThTwo">
          <span>{{ item.name }}</span></div>
        <div class="myTh myThThree">
          <span>{{ currentShowSchoolInfo == 1 ? item.schoolName : item.collegeName }}</span></div>
        <div class="myTh myThFour">{{ item.scoreTotal }}</div>
      </div>
    </div>
    <div class="bottomBox">
      <img class="Decoration" src="https://mc.posedu.com.cn/myAll_Img/bot_left_Decoration.png" />
      <img class="Decoration" src="https://mc.posedu.com.cn/myAll_Img/bot_right_Decoration.png" />
    </div>
  </div>

</template>
<script>
export default {
  data() {
    return {
      grade_rank: '', //选手排行列表
      pagesArr: ['/pages/index', '/pages/playerQuestions', '/pages/scoring', '/pages/playerRanking',
        '/pages/countdown', '/pages/totalScore_player'
      ], //首页banner、选题、打分、排行、倒计时、总分
      matchId: '',
      rankingStatus:0,  //0：按出场顺序排序   1：按选手成绩排序
      currentShowSchoolInfo:0,  //0:显示学院  1:显示学校
      currPage:1, //当前第几页
      grade_rankTime: null,
      data_acquisitionTime: null,
      collegeORschool: [],
      hostUrl: '',
      technicalSupportUrl: '',
          hostUrl:'',
        technicalSupportUrl:''
    };
  },
  mounted() {
    this.matchId = this.$route.query.matchId;
    this.$post("grade_college_list", {}, {
      matchId: this.matchId,
    }).then((res) => {
      console.log("学院信息", res.data);
      this.collegeORschool = res.data
    })
      .catch((err) => { });
    this.grade_rankFun()
    this.data_acquisition()
    this.hostUrl = sessionStorage.getItem('hostUrl')
    this.technicalSupportUrl = sessionStorage.getItem('technicalSupportUrl')
  },
  destroyed() {
    //console.log("销毁");
    let that = this
    // 销毁enter事件
    window.clearTimeout(that.grade_rankTime)
    window.clearTimeout(that.data_acquisitionTime)
  },
  methods: {
    grade_rankFun() {
      let that = this
      this.$post("grade_rank", {}, {
        matchId: this.matchId,
      }).then((res) => {
        console.log(res.data);
        this.currPage = res.data.currPage
        this.grade_rank = res.data.list
        this.grade_rankTime = window.setTimeout(() => {
          that.grade_rankFun()
        }, 1000);
      })
        .catch((err) => { });
    },
    data_acquisition() {
      let that = this
      this.$get("gerSecondConsoleInfo", '?trackId=' + 1, {
        matchId: this.matchId,
      }).then((res) => {
        this.currentShowSchoolInfo = res.data.currentShowSchoolInfo
        sessionStorage.setItem('screenModal', res.data.currentScreenModal?res.data.currentScreenModal:1)
        if(res.data.currentScreenModal && res.data.currentScreenModal!=1){
              window.location.reload();
            }
        //console.log('gerSecondConsoleInfo', res.data);
        if (res.data.type == 9) {
          this.rankingStatus = res.data.rankingStatus
          this.data_acquisitionTime = window.setTimeout(() => {
            that.data_acquisition()
          }, 1000);
        } else {
          let that = this
          let routerNum = null
          if (res.data.type == null) {
            routerNum = 0
          } else if (res.data.type == 4) {
            routerNum = 1
          } else if (res.data.type == 3 || res.data.type == 5 || res.data.type == 10) {
            routerNum = 2
          } else if (res.data.type == 1 || res.data.type == 2 || res.data.type == 7) {
            routerNum = 4
          } else if (res.data.type == 6) {
            routerNum = 5
          }
          if (routerNum != null) {
            this.$router.push({
              path: this.pagesArr[routerNum],
              query: {
                matchId: this.matchId,
                soundOver: true
              },
            });
            window.clearTimeout(that.circulateFunTime)
          }
        }
      })
        .catch((err) => { });
    },
  }
}

</script>
<style scoped>
* {
  padding: 0;
  margin: 0;
}

body {
  margin: 0;
  padding: 0;
}

.indexBox {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-image: url(https://mc.posedu.com.cn/myAll_Img/backOne.png);
  overflow: hidden;
}

.bigTitleBack {
  background-image: url(https://mc.posedu.com.cn/myAll_Img/bigTitle.png);
  font-size: 2.8125rem;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  width: 70.9375rem;
  height: 5rem;
  display: flex;
  justify-content: center;

}

.bigTitleBack .bigTitle {
  color: #4997FE;
  background-image: -webkit-linear-gradient(top, #79CBFB, #4997FE);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.tableBox {
  width: calc(100% - 8.75rem);
  margin-top: 2.7%;
  position: relative;
  z-index: 2;
}

.tableBox_title,
.tableBox_main {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  background: linear-gradient(180deg, rgba(14, 240, 235, 0.8) 0%, rgba(39, 114, 240, 0.8) 100%);
  color: #fff;
  font-size: 2.125rem;
  font-family: DIN Condensed-Bold, DIN Condensed;
  width: 100%;
  height: 5.3125rem;
  align-items: center;
  border-radius: 1.6875rem 1.6875rem 0 0;
}

.tableBox_main {
  color: #0E357A;
  font-size: 2.375rem;
  height: 7.5vh;
  max-height: 5rem;
  border-top: none;
  background: rgb(255, 255, 255, 0.8);
  border-radius: 0 0 0 0;
}

.myTh {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 0.1875rem solid rgba(255, 255, 255, 0.5);
}

.tableBox_main {
  border-bottom: 0.1875rem solid rgba(255, 255, 255, 0.5);
}

.myTh span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 0.625rem;
}

.myTh:nth-child(4n) {
  border-right: none;
}

/* .tableBox_main .myTh:nth-child(4n),
  .tableBox_main .myTh:nth-child(4n-3) {
    font-size: 3.75rem;
  }

  .tableBox_main .myTh:nth-child(4n-1) {
    font-size: 2rem;
  }

  .tableBox_main .myTh:nth-child(4n-2) {
    font-size: 2.625rem;
  } */

.tableBox_main:last-child {
  border-bottom: none;
  border-radius: 0 0 1.6875rem 1.6875rem;
}

.myThOne {
  width: 13%;
  font-size: 3.75rem;
}

.myThTwo {
  width: 17%;
  font-size: 2.625rem;
}

.myThThree {
  width: 39%;
  font-size: 2rem;
}

.myThFour {
  width: 30%;
  font-size: 3.75rem;
}

.bottomBox {
  margin-top: 1.25rem;
  width: calc(100% - 15.625rem);
  position: absolute;
  bottom: 5vh;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/pages/playerRanking.vue